import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ImageModalComponent } from "../components/image-modal/image-modal.component";

export interface ImageModalData {
	imageSrc: string;
	title: string;
	altText?: string;
}

@Injectable({
	providedIn: "root",
})
export class ImageModalService {
	constructor(private readonly dialog: MatDialog) {}

	public openImageModal(
		data: ImageModalData
	): MatDialogRef<ImageModalComponent> {
		return this.dialog.open(ImageModalComponent, {
			data,
			maxWidth: "90vw",
			maxHeight: "90vh",
			panelClass: "image-modal-panel",
			autoFocus: false,
			restoreFocus: true,
		});
	}

	public showImage(
		imageSrc: string,
		title: string,
		altText?: string
	): Observable<void> {
		const dialogRef = this.openImageModal({
			imageSrc,
			title,
			altText: altText || title,
		});

		return dialogRef.afterClosed();
	}
}
